import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

// TODO: 替换为真实的 iOS 下载地址（App Store 或 TestFlight）
const IOS_APPSTORE_URL = "https://apps.apple.com/your-app-link";
const IOS_TESTFLIGHT_URL = "https://testflight.apple.com/your-testflight-link";

const FEATURES = [
  { icon: "ri-chat-3-line", key: "download.feature.msg", descKey: "download.feature.msg.desc", color: "#00D2A8" },
  { icon: "ri-vidicon-line", key: "download.feature.call", descKey: "download.feature.call.desc", color: "#F7C948" },
  { icon: "ri-group-line", key: "download.feature.group", descKey: "download.feature.group.desc", color: "#A78BFA" },
  { icon: "ri-file-transfer-line", key: "download.feature.file", descKey: "download.feature.file.desc", color: "#F97316" },
  { icon: "ri-shield-keyhole-line", key: "download.feature.encrypt", descKey: "download.feature.encrypt.desc", color: "#34D399" },
  { icon: "ri-notification-3-line", key: "download.feature.notify", descKey: "download.feature.notify.desc", color: "#60A5FA" },
];

export default function IosDownload() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--bg-base)" }}>
      <Navbar />
      <main className="pt-24 pb-20">
        {/* Hero */}
        <section className="relative py-20 overflow-hidden">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: "linear-gradient(var(--grid-line) 1px, transparent 1px), linear-gradient(90deg, var(--grid-line) 1px, transparent 1px)",
              backgroundSize: "60px 60px",
            }}
          />
          <div
            className="absolute top-0 right-1/3 w-[500px] h-[400px] rounded-full pointer-events-none"
            style={{ backgroundColor: "var(--glow-secondary)", filter: "blur(100px)" }}
          />

          <div className="relative max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              {/* Left */}
              <div>
                <div
                  className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 mb-6 border"
                  style={{
                    backgroundColor: "var(--border-color)",
                    borderColor: "var(--border-hover)",
                  }}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-apple-line" style={{ color: "var(--text-primary)" }}></i>
                  </div>
                  <span className="text-xs font-medium" style={{ color: "var(--text-primary)" }}>
                    {t("download.ios.badge")}
                  </span>
                </div>

                <h1
                  className="text-4xl md:text-5xl font-extrabold leading-tight mb-5"
                  style={{ color: "var(--text-primary)" }}
                >
                  {t("download.ios.title")}
                </h1>
                <p className="text-base leading-relaxed mb-8 max-w-lg" style={{ color: "var(--text-secondary)" }}>
                  {t("download.ios.desc")}
                </p>

                {/* Download buttons */}
                <div className="flex flex-col sm:flex-row gap-3 mb-6">
                  {/* App Store */}
                  <a
                    href={IOS_APPSTORE_URL}
                    className="inline-flex items-center gap-3 font-bold text-base px-7 py-4 rounded-2xl transition-colors cursor-pointer whitespace-nowrap border"
                    style={{
                      backgroundColor: "var(--text-primary)",
                      color: "var(--bg-base)",
                      borderColor: "var(--text-primary)",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.9")}
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                  >
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-apple-fill text-xl"></i>
                    </div>
                    <div className="text-left">
                      <div className="text-xs leading-none mb-0.5 opacity-60">Download on the</div>
                      <div className="font-bold text-sm leading-none">App Store</div>
                    </div>
                  </a>

                  {/* TestFlight */}
                  <a
                    href={IOS_TESTFLIGHT_URL}
                    className="inline-flex items-center gap-3 text-base px-7 py-4 rounded-2xl transition-colors cursor-pointer whitespace-nowrap border"
                    style={{
                      backgroundColor: "var(--bg-surface)",
                      borderColor: "var(--border-hover)",
                      color: "var(--text-primary)",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.borderColor = "var(--text-primary)")}
                    onMouseLeave={(e) => (e.currentTarget.style.borderColor = "var(--border-hover)")}
                  >
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-flask-line text-lg" style={{ color: "var(--accent)" }}></i>
                    </div>
                    <div className="text-left">
                      <div className="text-xs leading-none mb-0.5" style={{ color: "var(--text-secondary)" }}>Beta via</div>
                      <div className="font-bold text-sm leading-none" style={{ color: "var(--text-primary)" }}>TestFlight</div>
                    </div>
                  </a>
                </div>

                {/* Tip */}
                <p className="text-xs flex items-center gap-1.5 mb-6" style={{ color: "var(--text-muted)" }}>
                  <i className="ri-information-line"></i>
                  {t("download.ios.tip")}
                </p>

                {/* Android link */}
                <button
                  onClick={() => navigate("/download/android")}
                  className="inline-flex items-center gap-1.5 text-sm transition-colors cursor-pointer"
                  style={{ color: "var(--text-secondary)" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "var(--accent)")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-secondary)")}
                >
                  <i className="ri-android-line" style={{ color: "var(--accent)" }}></i>
                  Looking for Android version? →
                </button>
              </div>

              {/* Right: iPhone mockup */}
              <div className="flex items-center justify-center">
                <div className="relative">
                  <div
                    className="w-64 h-[540px] rounded-[48px] overflow-hidden relative border-2"
                    style={{ backgroundColor: "var(--bg-surface)", borderColor: "var(--border-hover)" }}
                  >
                    {/* Dynamic Island */}
                    <div
                      className="absolute top-3 left-1/2 -translate-x-1/2 w-24 h-6 rounded-full z-10 flex items-center justify-center gap-3"
                      style={{ backgroundColor: "var(--bg-base)" }}
                    >
                      <div className="w-2 h-2 rounded-full" style={{ backgroundColor: "var(--border-color)" }}></div>
                      <div className="w-3.5 h-3.5 rounded-full border" style={{ borderColor: "var(--border-hover)" }}></div>
                    </div>
                    <img
                      src="https://readdy.ai/api/search-image?query=iPhone%20messaging%20app%20dark%20theme%20minimal%20clean%20UI%20chat%20interface%20contacts%20green%20accent%20color%20modern%20iOS%20design%20beautiful&width=256&height=536&seq=ios-screen1&orientation=portrait"
                      alt="iOS app screenshot"
                      className="w-full h-full object-cover object-top"
                    />
                    <div
                      className="absolute bottom-2 left-1/2 -translate-x-1/2 w-24 h-1 rounded-full"
                      style={{ backgroundColor: "var(--text-muted)" }}
                    ></div>
                  </div>
                  {/* Glow */}
                  <div
                    className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-48 h-12 pointer-events-none"
                    style={{ backgroundColor: "var(--glow-secondary)", filter: "blur(16px)" }}
                  />
                  {/* Floating badge */}
                  <div
                    className="absolute -left-10 top-20 rounded-2xl px-4 py-3 border"
                    style={{ backgroundColor: "var(--bg-surface)", borderColor: "var(--border-hover)" }}
                  >
                    <div className="flex items-center gap-2.5">
                      <div
                        className="w-8 h-8 flex items-center justify-center rounded-xl"
                        style={{ backgroundColor: "var(--border-color)" }}
                      >
                        <i className="ri-apple-line" style={{ color: "var(--text-primary)" }}></i>
                      </div>
                      <div>
                        <div className="text-xs font-semibold" style={{ color: "var(--text-primary)" }}>iOS 15.0+</div>
                        <div className="text-xs" style={{ color: "var(--text-secondary)" }}>Supported</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features grid */}
        <section className="py-20" style={{ backgroundColor: "var(--bg-subtle)" }}>
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-14">
              <h2 className="text-2xl md:text-3xl font-extrabold mb-3" style={{ color: "var(--text-primary)" }}>
                Core Features
              </h2>
              <p className="text-sm max-w-md mx-auto" style={{ color: "var(--text-secondary)" }}>
                Premium communication experience on iOS &amp; iPadOS
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {FEATURES.map((f) => (
                <div
                  key={f.key}
                  className="rounded-2xl p-6 transition-all group border"
                  style={{
                    backgroundColor: "var(--bg-surface)",
                    borderColor: "var(--border-color)",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.borderColor = "var(--border-hover)")}
                  onMouseLeave={(e) => (e.currentTarget.style.borderColor = "var(--border-color)")}
                >
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-xl mb-4 transition-all group-hover:scale-105"
                    style={{ backgroundColor: `${f.color}15` }}
                  >
                    <i className={`${f.icon} text-lg`} style={{ color: f.color }}></i>
                  </div>
                  <h3 className="text-base font-semibold mb-1.5" style={{ color: "var(--text-primary)" }}>
                    {t(f.key)}
                  </h3>
                  <p className="text-sm leading-relaxed" style={{ color: "var(--text-secondary)" }}>
                    {t(f.descKey)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Screenshots */}
        <section className="py-20" style={{ backgroundColor: "var(--bg-base)" }}>
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-2xl font-extrabold text-center mb-12" style={{ color: "var(--text-primary)" }}>
              App Screenshots
            </h2>
            <div className="flex gap-5 justify-center flex-wrap">
              {[
                { seq: "ss-ios-1", label: "Messages" },
                { seq: "ss-ios-2", label: "Contacts" },
                { seq: "ss-ios-3", label: "Video Call" },
                { seq: "ss-ios-4", label: "Settings" },
              ].map((s) => (
                <div key={s.seq} className="flex flex-col items-center gap-3">
                  <div
                    className="w-40 h-[300px] rounded-3xl overflow-hidden border"
                    style={{ backgroundColor: "var(--bg-surface)", borderColor: "var(--border-color)" }}
                  >
                    <img
                      src={`https://readdy.ai/api/search-image?query=iPhone%20iOS%20app%20dark%20theme%20instant%20messaging%20$%7Bs.label%7D%20interface%20modern%20UI%20minimal%20clean%20design%20beautiful&width=160&height=300&seq=${s.seq}&orientation=portrait`}
                      alt={s.label}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <p className="text-xs" style={{ color: "var(--text-secondary)" }}>{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom CTA */}
        <section className="py-16" style={{ backgroundColor: "var(--bg-subtle)" }}>
          <div className="max-w-2xl mx-auto px-6 text-center">
            <div
              className="rounded-3xl p-10 border"
              style={{ backgroundColor: "var(--bg-surface)", borderColor: "var(--border-color)" }}
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-5"
                style={{ backgroundColor: "var(--border-color)" }}
              >
                <i className="ri-apple-line text-2xl" style={{ color: "var(--text-primary)" }}></i>
              </div>
              <h3 className="text-2xl font-extrabold mb-3" style={{ color: "var(--text-primary)" }}>
                {t("download.ios.cta.title")}
              </h3>
              <p className="text-sm mb-8" style={{ color: "var(--text-secondary)" }}>
                {t("download.ios.cta.desc")}
              </p>
              <div className="flex flex-wrap justify-center gap-3">
                <a
                  href={IOS_APPSTORE_URL}
                  className="inline-flex items-center gap-2.5 font-bold text-sm px-7 py-3.5 rounded-2xl transition-colors cursor-pointer whitespace-nowrap"
                  style={{ backgroundColor: "var(--text-primary)", color: "var(--bg-base)" }}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.9")}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                >
                  <i className="ri-apple-fill"></i>
                  App Store
                </a>
                <a
                  href={IOS_TESTFLIGHT_URL}
                  className="inline-flex items-center gap-2.5 text-sm px-7 py-3.5 rounded-2xl transition-colors cursor-pointer whitespace-nowrap border"
                  style={{
                    borderColor: "var(--border-hover)",
                    color: "var(--text-primary)",
                    backgroundColor: "transparent",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.borderColor = "var(--text-primary)")}
                  onMouseLeave={(e) => (e.currentTarget.style.borderColor = "var(--border-hover)")}
                >
                  <i className="ri-flask-line" style={{ color: "var(--accent)" }}></i>
                  TestFlight
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}